import onBreakpointChange from '../utils/onBreakpointChange';

export default class ContentMenu {
  constructor() {
    this.selector = '.b-content-menu';

    this.selectors = {
      section: '.page__content .c-block',
      link: '.js-content-menu__menu a',
      toggle: '.b-content-menu__toggle',
      item: '.b-content-menu__item',
      toggleSpan: '.b-content-menu__toggle-span',
      body: '.b-content-menu__inner',
    };
  }

  bootstrap() {
    const blocks = [ ...document.querySelectorAll(this.selector) ];
    const sections = [ ...document.querySelectorAll(this.selectors.section) ];

    if (blocks.length === 0) {
      return;
    }

    blocks.forEach(block => {
      const links = [ ...block.querySelectorAll(this.selectors.link) ];
      const toggle = block.querySelector(this.selectors.toggle);
      const items = block.querySelectorAll(this.selectors.item);
      const toggleSpan = block.querySelector(this.selectors.toggleSpan);
      const body = block.querySelector(this.selectors.body);

      const firstItem = document.querySelector('.js-content-menu__menu a:first-child');

      toggleSpan.innerHTML = firstItem.innerHTML;

      const bodyHeight = body.offsetHeight + 20;

      window.addEventListener('scroll', () => {
        sections.forEach(section => {
          const container = section.getAttribute('id');
          const containerOffset = section.getBoundingClientRect().top + window.scrollY;
          const containerHeight = section.clientHeight;
          const containerBottom = containerOffset + containerHeight - 140;
          const scrollPosition = document.scrollingElement.scrollTop;

          if (scrollPosition < containerBottom && scrollPosition >= containerOffset - 140) {
            const currentItem = document.querySelector(`.js-content-menu__menu a[href="#${container}"]`);

            links.forEach(link => {
              link.parentNode.classList.remove('active');
            });

            if (currentItem) {
              currentItem.parentNode.classList.add('active');
              toggleSpan.innerHTML = currentItem.innerHTML;
              window.history.pushState(null, null, `${currentItem.getAttribute('href')}`);
            }
          }
        });
      });

      toggle.addEventListener('click', event => {
        event.target.classList.toggle('active');
      });

      items.forEach(item => {
        item.addEventListener('click', () => {
          toggle.classList.toggle('active');
        });
      });

      onBreakpointChange(
        991,
        () => {
          body.style.setProperty('max-height', '0px');
          body.style.setProperty('--acc-original-height', `${bodyHeight}px`);
        },
        'down',
      );

      onBreakpointChange(
        991,
        () => {
          body.style.setProperty('max-height', 'max-content');
          body.style.setProperty('--acc-original-height', `${bodyHeight}px`);
        },
        'up',
      );
    });
  }
}
